import Button, { ButtonProps } from "@mui/material/Button";
import Progress from "@mui/material/CircularProgress";

interface LoadingButtonProps {
  loading?: boolean;
  indicatorSize?: number;
  children: React.ReactNode;
}

const LoadingButton: React.FC<ButtonProps & LoadingButtonProps> = ({
  children,
  loading = false,
  indicatorSize = 22,
  ...rest
}) => {
  return (
    <Button disabled={loading} {...rest}>
      {loading ? (
        <Progress
          size={indicatorSize}
          sx={{ color: "white", my: loading && 0.2 }}
        />
      ) : (
        children
      )}
    </Button>
  );
};

export default LoadingButton;
